import {
	COMMON_IMAGE,
	CURSOR,
	drawBorderLines,
	drawRectangle,
	getTextColor,
	getTrimmedText,
	GROUP_SECTION_WIDTH,
	GROUP_TYPE,
	GROUP_SECTION_TEXT_GREY_DARK,
	GROUP_SECTION_TEXT_GREY,
	getFontHeight,
	GROUP_SECTION_BADGE_PADDING_HORIZONTAL,
	GROUP_SECTION_BADGE_PADDING_VERTICAL,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
	drawBorder,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {PROJECT_STATUS} from '../../../../constants';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class ProjectGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT, data);
	}

	refreshData(updatedProject) {
		this.data.name = updatedProject.name;
		this.data.color = updatedProject.projectColor;
		this.data.clientName = updatedProject.client ? updatedProject.client.name : null;
		this.data.status = updatedProject.status;
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		console.log("disabled: ", this.data.disabled);
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this, collapsableSectionHeight);
			const {clientName, name, id, color, companyProjectId, companyProjectGroupId, isConnectedProject} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const left = x + this.marginX;
			const planning = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.OPPORTUNITY].includes(data.status);
			const center = y + (height / 2);
			const borderThickness = 1;

			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			// draw project colored border
			drawBorder(
				canvasContext,
				x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
				y - 1 - (borderThickness * 2),
				height,
				true,
				color,
				GROUP_SECTION_PROJECT_BORDER_WIDTH,
			);

			// draw project badge
			const projectIdBorderRadius = 4;
			const projectId = `${isConnectedProject ? 'X' : 'P'}${isConnectedProject ? companyProjectGroupId : companyProjectId}`;
			const projectIdWidth = canvasContext.measureText(projectId).width;
			let projectIdHeight = getFontHeight(canvasContext);
			const iconSize = 14;
			const iconProjectIdGap = 10;

			// size
			const badgeWidth = isConnectedProject
				? projectIdWidth + GROUP_SECTION_BADGE_PADDING_HORIZONTAL + iconSize + iconProjectIdGap
				: projectIdWidth + GROUP_SECTION_BADGE_PADDING_HORIZONTAL;
			const badgeHeight = isConnectedProject
				? iconSize + GROUP_SECTION_BADGE_PADDING_VERTICAL
				: projectIdHeight + GROUP_SECTION_BADGE_PADDING_VERTICAL;

			// position
			const badgeXPos = x + left + GROUP_SECTION_MARGIN_LEFT;
			const badgeYPos = center - (badgeHeight / 2);

			// draw badge
			drawRectangle(
				canvasContext,
				badgeXPos,
				badgeYPos,
				badgeWidth,
				badgeHeight,
				{
					backgroundColor: planning ? undefined : color,
					borderThickness: planning ? 2 : 0,
					borderColor: color,
					borderTopLeftRadius: projectIdBorderRadius,
					borderBottomLeftRadius: projectIdBorderRadius,
					borderTopRightRadius: projectIdBorderRadius,
					borderBottomRightRadius: projectIdBorderRadius,
				}
			);

			canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_DARK;
			const maxNameWidth = GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE() - badgeXPos - (badgeWidth + GROUP_SECTION_PADDING_LEFT) - GROUP_SECTION_ACTION_BUTTON_SIZE;

			//Drawing project id
			canvasContext.font = '700 10px ' + Util.getFontFamily();
			const projectIdOffset = isConnectedProject
				? badgeWidth - (GROUP_SECTION_BADGE_PADDING_HORIZONTAL / 2) - projectIdWidth
				: ((badgeWidth / 2) - (projectIdWidth / 2));
			const projectIdXPos = badgeXPos + projectIdOffset;
			canvasContext.fillText(
				projectId,
				projectIdXPos,
				center + (badgeHeight / 2) - (projectIdHeight / 2)
			);

			//Drawing project and client (if present) name
			canvasContext.font = '600 14px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(canvasContext, name, maxNameWidth);
			if (clientName) {
				const gapSize = 2.5;

				// project name
				canvasContext.fillText(
					formattedProjectName,
					badgeXPos + badgeWidth + GROUP_SECTION_PADDING_LEFT,
					center + (badgeHeight / 2) - (getFontHeight(canvasContext) / 2) - gapSize,
				);

				canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY;

				// format client name
				canvasContext.font = '400 11px ' + Util.getFontFamily();
				const formattedClientName = getTrimmedText(
					canvasContext,
					clientName,
					maxNameWidth
				);

				// draw client name
				canvasContext.fillText(
					formattedClientName,
					badgeXPos + badgeWidth + GROUP_SECTION_PADDING_LEFT,
					center + (badgeHeight / 2) + (getFontHeight(canvasContext) / 2)
				);
			} else {
				// project name
				canvasContext.fillText(
					formattedProjectName,
					badgeXPos + badgeWidth + GROUP_SECTION_PADDING_LEFT,
					center + (getFontHeight(canvasContext) / 2),
				);
			}

			canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_DARK;

			// connected project icon
			if (isConnectedProject) {
				const iconPosX = badgeXPos + GROUP_SECTION_BADGE_PADDING_HORIZONTAL / 2;
				canvasContext.drawImage(
					cacheManager.getCommonImage(COMMON_IMAGE.CONNECTED_PROJECT_BLACK),
					iconPosX,
					center - (iconSize / 2),
					iconSize,
					iconSize
				);
			}
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this, collapsableSectionHeight);
			const {clientName, name, id, color, companyProjectId, companyProjectGroupId, isConnectedProject, isDisabled} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const left = x + this.marginX;
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const planning = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.OPPORTUNITY].includes(data.status);

			//Subtract 1 from width and height to make room for the grey border
			drawRectangle(canvasContext, left + 16, y, width - 17 - this.marginX, height - 1, {
				backgroundColor: isDisabled ? '#d4d4d4' : planning ? '#ffffff' : color,
				borderColor: color,
				borderThickness: !isDisabled && planning ? 2 : 0,
				borderTopLeftRadius: 10,
				borderBottomLeftRadius: expanded ? 0 : 10,
			});

			drawBorderLines(canvasContext, x, y, width, height);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			const textColor = planning || isDisabled ? '#2a2a2a' : getTextColor(color);

			//TODO check if connected
			canvasContext.fillStyle = textColor;
			//Drawing project id
			canvasContext.font = '700 10px ' + Util.getFontFamily();
			canvasContext.fillText(`${isConnectedProject ? 'X' : 'P'}${isConnectedProject ? companyProjectGroupId : companyProjectId}`, left + 30, y + (clientName ? 17 : 24));

			//Drawing project and client (if present) name
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(canvasContext, name, (isConnectedProject ? 130 : 140) + (isDisabled ? 30 : 0) - this.marginX);
			if (clientName) {
				canvasContext.fillText(formattedProjectName, left + 66, y + 18);
				canvasContext.font = '400 11px ' + Util.getFontFamily();
				const formattedClientName = getTrimmedText(canvasContext, clientName, 140 + (isDisabled ? 30 : 0) - this.marginX);
				canvasContext.fillText(formattedClientName, left + 66, y + 33);
			} else {
				canvasContext.fillText(formattedProjectName, left + (isConnectedProject ? 76 : 66), y + 25);
			}
			if (isConnectedProject) {
				canvasContext.drawImage(cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'CONNECTED_PROJECT_WHITE' : 'CONNECTED_PROJECT_BLACK']), left + 56, y + 13, 14, 14);
			}
		}
	}
}

export default ProjectGroup;
